<template>
  <div class="preview-div">
    <div class="preview-bg">
      <slot />
    </div>
  </div>
</template>

<script>
import PhoneImage from '../assets/phone.svg';

export default {
  name: 'PhonePreview',
  props: {},
  data() {
    return {
      phoneImage: PhoneImage,
    };
  },
};
</script>

<style scoped>
.preview-div {
  max-width: 300px;
  margin: 0 auto;
  background-image: url('../assets/phone.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  aspect-ratio: 1/2;
  position: relative;
}

.preview-bg {
  position: absolute;
  top: 15%;
  /* left: 11%; */
  max-width: 100%;
  height: 448px;
  overflow-x: auto;
  padding: 0 35px;
}
</style>
